import { Loading } from '@/components/loading/Loading';

import clsx from 'clsx';
import { motion } from 'framer-motion';
import { FC, HTMLAttributes, Suspense } from 'react';

export const Page: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className, ...props }) => {
  return (
    <motion.div
      className="flex w-full flex-1 bg-white bg-opacity-40 h-full"
      initial={{ transform: 'translateY(30px)', opacity: 0 }}
      animate={{ transform: 'translateY(0px)', opacity: 1 }}
    >
      <div className="p-6 overflow-y-auto w-full">
        <div
          {...props}
          className={clsx('border-secondary-std w-full flex-1 rounded-t-xl border bg-white bg-opacity-80', className)}
        >
          <Suspense fallback={<Loading />}>{children}</Suspense>
        </div>
      </div>
    </motion.div>
  );
};
